import type { ButtonHTMLAttributes } from "react";

import { Button } from "./Button";

export function RetryIcon({ className }: { className?: string }) {
  return (
    <svg
      className={["ui-retry-icon", className].filter(Boolean).join(" ")}
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12.75 7.75a4.75 4.75 0 1 1-1.39-3.36l1.39 1.41" />
      <path d="M12.75 2.75V5.8H9.7" />
    </svg>
  );
}

export function RetryButton({
  label,
  loading = false,
  className,
  ...props
}: Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "aria-label"> & {
  label: string;
  loading?: boolean;
}) {
  return (
    <Button
      {...props}
      tone="quiet"
      size="sm"
      className={["ui-retry-action", className].filter(Boolean).join(" ")}
      aria-label={loading ? `${label}, retrying` : label}
      title={label}
      loading={loading}
    >
      {!loading && <RetryIcon />}
    </Button>
  );
}
